export default "__VITE_ASSET__76dd6a21__"